import {DOCUMENT, NgClass} from '@angular/common';
import {Component, Inject, OnInit, Renderer2,} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '@config/config.service';
import {UnsubscribeOnDestroyAdapter} from '@shared';
import {AuthService} from '../../auth/auth.service';
import {Config} from '@config';
import {MatMenuModule} from '@angular/material/menu';
import {FeatherIconsComponent} from '@shared/components/feather-icons/feather-icons.component';
import {MatButtonModule} from '@angular/material/button';
import {fetchUserAttributes, signOut} from '@aws-amplify/auth';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    FeatherIconsComponent,
    MatMenuModule,
    NgClass
  ],
  providers: [],
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public config!: Config;
  userImg?: string;
  homePage?: string;
  isNavbarCollapsed = true;
  flagvalue: string | string[] | undefined;
  countryName: string | string[] = [];
  langStoreValue?: string;
  docElement?: HTMLElement;
  isFullScreen = false;
  usersName = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.config = this.configService.configData;
    this.userImg = 'assets/images/user/' + this.authService.currentUserValue.img;
    this.docElement = document.documentElement;

    this.homePage = 'organisation';
    fetchUserAttributes().then((user) => {
      this.usersName = user.name ?? '';
    })
  }

  callFullscreen() {
    if (!this.isFullScreen) {
      if (this.docElement?.requestFullscreen != null) {
        this.docElement?.requestFullscreen();
      }
    } else {
      document.exitFullscreen();
    }
    this.isFullScreen = !this.isFullScreen;
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }

    const hasClass2 = this.document.body.classList.contains('side-closed');
    if (hasClass2) {
      // this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      // this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'false');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'true');
    }
  }
  async logout() {
    await signOut();
    await this.router.navigate(['/auth/sign-in']);
  }
}
